import { For, Match, Switch } from "solid-js";
import { useI18n } from "@/api/i18n";
import { Badge } from "@/components/ui/badge";
import { subcategoryLabel } from "@/domains/freelance/taxonomy/store/taxonomy-store";
import type { OfferSubcategories } from "../utils/offer-subcategories";

export type SubcategorySummaryProps = {
  value: OfferSubcategories;
};

/**
 * The «Ambiti» line of the «Titolo e categoria» step card: the chosen
 * subcategories as badges, «Tutta la categoria», or the note that the AI will
 * choose them at publication. It renders the value it gets as it is; the
 * caller passes the value already made visible.
 */
export function SubcategorySummary(props: SubcategorySummaryProps) {
  const { t } = useI18n();

  return (
    <>
      <p class="text-sm text-muted-foreground mt-3">
        {t("jobOffers.refine.subcategories.label")}
      </p>
      <Switch>
        <Match when={props.value.kind === "chosen" && props.value}>
          {(chosen) => (
            <div class="flex flex-wrap gap-1">
              <For each={chosen().keys}>
                {(key) => (
                  <Badge variant="info-static">{subcategoryLabel(key)}</Badge>
                )}
              </For>
            </div>
          )}
        </Match>
        <Match when={props.value.kind === "whole"}>
          <p>{t("jobOffers.refine.subcategories.wholeCategory")}</p>
        </Match>
        <Match when={props.value.kind === "undeclared"}>
          <p class="text-sm text-muted-foreground">
            {t("jobOffers.refine.subcategories.undeclaredStep")}
          </p>
        </Match>
      </Switch>
    </>
  );
}
